import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.08073 4.75L4.9974 1.83333L7.91406 4.75" />
    <path d="M7.91927 8.25L5.0026 11.1667L2.08594 8.25" />
  </svg>
);
